import _ from 'lodash';
import { db } from '../../firebase';
import React, { Component } from 'react';
import moment from 'moment'
import request from 'request';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPencilAlt, faArrowAltCircleRight, faEnvelope, faFileCsv } from "@fortawesome/free-solid-svg-icons";
import stringWidth from "string-width"
import { CSVLink } from "react-csv";

import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';

import { addCheck, allCheck, deleteRecord } from '../../utils/common'

import Header from '../../components/header';
import Footer from '../../components/footer';
import Filter from '../../components/filter';

import skills from "../../data/skill.json";
import csv_headers from "../../data/csv_header.json";
const cast_ranks = [{"key": 0, "label": "新人に近い"}, {"key": 1, "label": "何でも受けられる"}]

const attribute_mst = {"0": "CP", "1": "定期"}
moment.locale("ja", {
  week: {
    dow: 1 //Monday is the first day of the week.
  }
});
const localizer = momentLocalizer(moment)

export default class Casts extends Component {
  constructor (props) {
    super(props);

    this.state = {
      casts: [],
      csv: [],
      messages: [],
      cast_id: "",
      message: "",
      schedules: [],
      user: {
        rank: 0, 
        name: "", 
        name_kana: "", 
        tel: "", 
        email: "", 
        address: "", 
        station: "", 
        emergency_tel: "", 
        smartphone: "", 
        bank_name: "",
        branch: "",
        account_number: "",
        account_name: "",
        skill_sweeping: 0,
        skill_cooking: 0,
        skill_cleaning: 0,
        skill_helper: 0,
        skill_care: 0,
        skill_restaurant: 0,
        skill_etc: 0,
        allergies: "",
        memo: "",
      },
      new_cast: {},
      submenu: "lists",
      contentmenu: "message",
      date: moment().format('YYYY/MM/DD'),
      schedule_id: "",
      start_time: "9:00",
      end_time: "9:30",
      repeat: false,
      sends: [],
      checks: {},
      all_check: "false",
      filter: "",
      users_tmp: [],
      schedule_mode: 0,
      on_submit: false,
      errors: {}
    };
  }

  componentWillMount () {
    db.ref('casts').orderByChild("delete").equalTo(null).on('value', snapshot => {
      var cast_tmp = snapshot.val()
      for (let key in cast_tmp) {
        cast_tmp[key]["id"] = key
      }
      var casts = _.values(cast_tmp)
      //console.log(casts)

      db.ref('chat').orderByChild('createdAt').on('value', snapshot => {
        const messages = snapshot.val()
        //console.log(messages)

        // ユーザーごとに最後のメッセージ見つけてcastsに追加
        for( let m in messages ) {
          for( let i in casts ) {
            if (casts[i]["id"] === m) {
              for( let n in messages[m]["messages"] ) {
                if (messages[m]["messages"][n]["contributor"] === "admin" || messages[m]["messages"][n]["contributor"] === "cast") {
                  casts[i]["last_message_date"] = messages[m]["messages"][n]["createdAt"];
                  casts[i]["last_message"] = messages[m]["messages"][n]["message"];
                }
              }
            }
          }
        }
        
        this.setState({ casts })
      });
    });
  }

  getMessage (id) {
    db.ref('chat/' + id + '/messages').on('value', snapshot => {
      const messages = _.values(snapshot.val())
      //console.log(list)
      this.setState({ messages })
    });

    db.ref('schedules/' + id).on('value', snapshot => {
      const schedules = snapshot.val()
      var schedules_tmp = []
      for (let key in schedules) {
        if ("true" === schedules[key].repeat) {
          // 繰り返し(100週分入れる)
          for (let i = 0; i < 100; i++) {
            schedules_tmp.push({title: "空き枠", schedule_id:key, start: new Date(moment(schedules[key].start).add(i, 'weeks').format('YYYY/MM/DD HH:mm:ss')), end: new Date(moment(schedules[key].end).add(i, 'weeks').format('YYYY/MM/DD HH:mm:ss')), repeat: "true"})
          }
        } else {
          schedules_tmp.push({title: "空き枠", schedule_id:key, start: new Date(moment(schedules[key].start).format('YYYY/MM/DD HH:mm:ss')), end: new Date(moment(schedules[key].end).format('YYYY/MM/DD HH:mm:ss')), repeat: "false"})
        }
      }
      db.ref('reservations/').on('value', snapshot => {
        const schedules = snapshot.val()
        for (let n in schedules) {
          for (let m in schedules[n]) {
            if (schedules[n][m]["cast_id"] === id) {
              //console.log(moment(schedules[n][m].date).format('YYYY/MM/DD HH:mm:ss'))
              schedules_tmp.push({title: "予約済み", start: new Date(moment(schedules[n][m].date).format('YYYY/MM/DD HH:mm:ss')), end: new Date(moment(schedules[n][m].date).add(schedules[n][m].lot, "m").format('YYYY/MM/DD HH:mm:ss'))})
            }
          }
        }
        //console.log(list)
        this.setState({ schedules: schedules_tmp })
      });
    });
  }

  changeSubMenu (menu_name) {
    this.setState({submenu: menu_name})
  }

  changeUser(user, id, name) {
    this.setState({ user: user, user_id: id, user_name: name })
    this.getMessage(id)
  }

  alt (e) {
    if (e) {
      var v = {}
      if ("DIV" === e.target.tagName) {
        v = {alt: true, alt_text: e.target.innerHTML, alt_x: e.currentTarget.getBoundingClientRect().left + 20, alt_y: e.currentTarget.getBoundingClientRect().top - 25}
        if (e.currentTarget.offsetWidth <= stringWidth(e.target.innerHTML) * 7.7) {
          this.handle = setTimeout(() => {
            this.setState(v)
          }, 300)
        }
      } else {
        v = {alt: true, alt_text: e.currentTarget.dataset.alt, alt_x: e.currentTarget.getBoundingClientRect().left + 10, alt_y: e.currentTarget.getBoundingClientRect().top - 25}
        this.handle = setTimeout(() => {
          this.setState(v)
        }, 300)
      }
    } else {
      clearTimeout(this.handle);
      this.setState({alt: false})
    }
  }

  editUser() {
    console.log(1)
  }

  setCastInfo(obj) {
    var user = this.state.user
    let k = Object.keys(obj)
    let v = Object.values(obj)
    user[k[0]] = v[0]
    if (k[0] === "menu") {
      user["menu_etc"] = ""
    }
    user["editing"] = 1
    this.setState({user: user})
  }

  addCastInfo(obj) {
    var new_cast = this.state.new_cast
    let k = Object.keys(obj)
    let v = Object.values(obj)
    new_cast[k[0]] = v[0]
    this.setState({new_cast: new_cast})
  }

  editConfirm(id) {
    var data = _.cloneDeep(this.state.user);
    data.adminUpdatedAt = Date.now();

    console.log(data)

    db.ref("casts/" + id).update(data).then(function() {// Update successful.
      //window.location.href = process.env.REACT_APP_PUBLIC_URL + "/admin_pre_users";
      window.location.href = "admin_casts";
    }).catch(function (error) {
      // An error happened.
    });
    
  }

  send(cast_id, message) {
    console.log("send ", cast_id, " ", message)

    var line_send_url = process.env.REACT_APP_FUNCTIONS_URL + "/send"
    var options = {
      uri: line_send_url,
      headers: {
        "Content-type": "application/json",
      },
      json: {
        "user_id": cast_id,
        "message": message,
        "contributor": "cast"
      }
    }

    var scope = this
    request.post(options, function(error, response, body){
      scope.setState({message: ""})
    });
  }

  changeStateFromChild (e) {
    this.setState(e)
  }

  validation (e) {
    //console.log(this.state)
    var errors = {}

    this.setState({errors: errors}, () => {
      if (Object.keys(this.state.errors).length === 0) {
        this.addCast()
      }
    });
  }

  addCast(e) {

    var data = _.cloneDeep(this.state.new_cast);
    data.createdAt = Date.now();

    var scope = this

    /*const user_info = {
      rank: data.rank,
      name: data.name,
      name_kana: data.name_kana,
      tel: data.tel,
      email: data.email,
      address: data.address,
      station: data.station,
      emergency_tel: data.emergency_tel,
      smartphone: data.smartphone,
      bank_name: data.bank_name,
      branch: data.branch,
      account_number: data.account_number,
      account_name: data.account_name,
      skill_sweeping: data.skill_sweeping,
      skill_cooking: data.skill_cooking,
      skill_cleaning: data.skill_cleaning,
      skill_helper: data.skill_helper,
      skill_care: data.skill_care,
      skill_restaurant: data.skill_restaurant,
      skill_etc: data.skill_etc,
      allergies: data.allergies,
      memo: data.memo,
      createdAt: data.createdAt
    }*/

    console.log(data)

    var cast_id = db.ref(`casts`).push().key
    data.id = cast_id

    db.ref(`casts/` + cast_id).update(data).then(function() {
      // Update successful.
    }).then(function() {
      window.location.href = "/admin_casts"
    }).catch(function (error) {
      // An error happened.
      scope.setState({on_submit: false});
      scope.setState({errors: {"server": "サーバーとの通信に失敗しました。大変お手数ですが、数分後に再度やり直してください"}})
    });
  }

  addSchedule(id) {
    var data = _.cloneDeep(this.state);

    //console.log(id, schedule_info)

    var scope = this

    if (this.state.schedule_mode === 0) {
      const schedule_info = {
        start: moment(data.date + " " + data.start_time).valueOf(),
        end: moment(data.date + " " + data.end_time).valueOf(),
        repeat: data.repeat,
        createdAt: Date.now()
      }
      db.ref('schedules/' + id).push(schedule_info).then(function() {
        // Update successful.
      }).then(function() {
        //scope.props.history.push("/admin_casts");
        scope.getMessage(id)
      }).catch(function (error) {
        // An error happened.
        scope.setState({errors: {"server": "サーバーとの通信に失敗しました。大変お手数ですが、数分後に再度やり直してください"}})
      });
    } else {
      const schedule_info = {
        start: moment(data.date + " " + data.start_time).valueOf(),
        end: moment(data.date + " " + data.end_time).valueOf(),
        repeat: data.repeat,
        updatedAt: Date.now()
      }
      db.ref('schedules/' + id + "/" + data.schedule_id).update(schedule_info).then(function() {
        // Update successful.
      }).then(function() {
        //scope.props.history.push("/admin_casts");
        scope.getMessage(id)
      }).catch(function (error) {
        // An error happened.
        scope.setState({errors: {"server": "サーバーとの通信に失敗しました。大変お手数ですが、数分後に再度やり直してください"}})
      });
    }
  }

  onSlotChange(slotInfo) {
    this.setState({schedule_mode: 0})
    this.setState({schedule_id: "", date: moment(slotInfo.start.toLocaleString()).format("YYYY/MM/DD"), start_time: moment(slotInfo.start.toLocaleString()).format("HH:mm"), end_time: moment(slotInfo.end.toLocaleString()).format("HH:mm"), repeat: "false"})
  }

  onEventClick(event) {
    this.setState({schedule_mode: 1})
    console.log(event) //Shows the event details provided while booking
    this.setState({schedule_id: event.schedule_id, date: moment(event.start.toLocaleString()).format("YYYY/MM/DD"), start_time: moment(event.start.toLocaleString()).format("HH:mm"), end_time: moment(event.end.toLocaleString()).format("HH:mm"), repeat: event.repeat})
  }

  render () {

    const cast_list = this.state.casts.map((cast, i) => {
      let name = cast.lastName
      if (cast.name) {
        name = cast.name
      }
      return <li key={i} className={[cast.id === this.state.user_id ? "user active" : "user"]} onClick={e => this.changeUser(cast, cast.id, name)}>
        <img src={cast.picture} alt="" className="profile" height="30" />
        <div>
          <p className="message_date">{moment(cast.last_message_date).format('YYYY/MM/DD')}</p>
          <p className="user_name">{name.substr(0, 15)}</p>
          <p className="message_summary">{cast.last_message ? cast.last_message.substr(0, 15) : ""}...</p>
        </div>
      </li>
      ;
    });

    const cast_detail_list = this.state.casts.map(user => {
      let name = user.lastName
      if (user.name) {
        name = user.name
      }
      return <li key={user.id} className={[user.id === this.state.user_id ? "user active" : "user"]} onClick={e => this.changeUser(user, user.id, name)} onDoubleClick={e => this.changeSubMenu("operation")}>
        <div><img alt="□" src={"/images/check_" + this.state.checks[user.id] + ".png"} onClick={e => addCheck(user.id, name, user.email, this.state.casts, this.state.sends, this.state.checks, this.state.all_check, (callback) => {this.setState(callback)})} className="checkbox_image" /></div>
        <div><span className={[user.attribute === "0" ? "cp" : ""]}>{attribute_mst[user.attribute]}</span></div>
        <div><img src={user.picture ? user.picture : "/images/user.png"} alt="" className="profile" height="30" /></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{name}</div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{user.address}</div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{user.apartment}</div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source"></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{user.tel}</div>
        <div><a href={"mailto:" + user.email}>{user.email}</a></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{user.menu}</div>
        <div>{moment(user.createdAt).format('MM/DD(dddd) HH:mm')}</div>
        <div></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{user.memo}</div>
        <div>
          <p data-alt="編集" onClick={e => this.editUser()} onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()}><FontAwesomeIcon icon={faPencilAlt} /></p>
          <p data-alt="削除" onClick={e => deleteRecord(name, "casts/" + user.id, "/admin_casts")} onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()}><FontAwesomeIcon icon={faTrash} /></p>
          <p data-alt="オペレーション" onClick={e => this.changeSubMenu("operation")} onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()}><FontAwesomeIcon icon={faArrowAltCircleRight} /></p>
        </div>
      </li>
      ;
    });

    const message_list = this.state.messages.map(message => {
      let ret
      if (message.contributor === "admin" || message.contributor === "cast") {
        ret = <li className="message">
          <div>
            <p className="message_date">{moment(message.createdAt).format('YYYY/MM/DD HH:mm')}</p>
            <p className="message_body"><span>{[message.contributor === "admin" ? "あなた：" : ""]}</span>{message.message}</p>
          </div>
        </li>
        ;
      }
      return ret
    });

    const skill_list = skills.map((skill, i) => {
      return <option key={i} value={skill.value}>{skill.label}</option>;
    });

    const dates = [];
    moment.updateLocale('ja', {weekdays: ["日", "月", "火", "水", "木", "金", "土"]});
    for (let i = 0; i <= 30; i++) {
      dates.push(
        <option key={i} value={moment().add(i, 'days').format('YYYY/MM/DD')}>{moment().add(i, 'days').format('YYYY年MM月DD日(dddd)')}</option>
      )
    }

    const user_edit = () => {
      if (this.state.user_id) {
        let rank = 0
        if (this.state.user.rank) {
          rank = this.state.user.rank
        }
        return <div className="information-contents-wrapper">
          <dl>
            <dt>ユーザータイプ</dt><dd><select name="rank" value={rank} onChange={e => this.setCastInfo({rank: e.target.value})}>
              <option value="0">新人に近い</option>
              <option value="1">何でも受けられる</option>
            </select></dd>
            <dt>氏名</dt><dd><input type="text" value={this.state.user.name} onChange={e => this.setCastInfo({name: e.target.value})} /></dd>
            <dt>フリガナ</dt><dd><input type="text" value={this.state.user.name_kana} onChange={e => this.setCastInfo({name_kana: e.target.value})} /></dd>
            <dt>電話番号</dt><dd><input type="text" value={this.state.user.tel} onChange={e => this.setCastInfo({tel: e.target.value})} /></dd>
            <dt>メールアドレス</dt><dd><input type="text" value={this.state.user.email} onChange={e => this.setCastInfo({email: e.target.value})} /></dd>
            <dt>住所</dt><dd><input type="text" value={this.state.user.address} onChange={e => this.setCastInfo({address: e.target.value})} /></dd>
            <dt>最寄駅</dt><dd><input type="text" value={this.state.user.station} onChange={e => this.setCastInfo({station: e.target.value})} /></dd>
            <dt>緊急連絡先</dt><dd><input type="text" value={this.state.user.emergency_tel} onChange={e => this.setCastInfo({emergency_tel: e.target.value})} /></dd>
            <dt>所有スマートフォン</dt><dd><input type="text" value={this.state.user.smartphone} onChange={e => this.setCastInfo({smartphone: e.target.value})} /></dd>
            <dt>振込先銀行名</dt><dd><input type="text" value={this.state.user.bank_name} onChange={e => this.setCastInfo({bank_name: e.target.value})} /></dd>
            <dt>振込先支店名</dt><dd><input type="text" value={this.state.user.branch} onChange={e => this.setCastInfo({branch: e.target.value})} /></dd>
            <dt>振込先口座番号</dt><dd><input type="text" value={this.state.user.account_number} onChange={e => this.setCastInfo({account_number: e.target.value})} /></dd>
            <dt>振込先口座名義</dt><dd><input type="text" value={this.state.user.account_name} onChange={e => this.setCastInfo({account_name: e.target.value})} /></dd>
            <dt>家事代行（掃除）経験</dt><dd><select value={this.state.user.skill_sweeping} onChange={e => this.setCastInfo({skill_sweeping: e.target.value})}>{skill_list}</select></dd>
            <dt>家事代行（料理）経験</dt><dd><select value={this.state.user.skill_cooking} onChange={e => this.setCastInfo({skill_cooking: e.target.value})}>{skill_list}</select></dd>
            <dt>ハウスクリーニング経験</dt><dd><select value={this.state.user.skill_cleaning} onChange={e => this.setCastInfo({skill_cleaning: e.target.value})}>{skill_list}</select></dd>
            <dt>ホームヘルパー経験</dt><dd><select value={this.state.user.skill_helper} onChange={e => this.setCastInfo({skill_helper: e.target.value})}>{skill_list}</select></dd>
            <dt>介護経験</dt><dd><select value={this.state.user.skill_care} onChange={e => this.setCastInfo({skill_care: e.target.value})}>{skill_list}</select></dd>
            <dt>飲食店経験</dt><dd><select value={this.state.user.skill_restaurant} onChange={e => this.setCastInfo({skill_restaurant: e.target.value})}>{skill_list}</select></dd>
            <dt>その他清掃業務経験</dt><dd><select value={this.state.user.skill_etc} onChange={e => this.setCastInfo({skill_etc: e.target.value})}>{skill_list}</select></dd>
            <dt>アレルギー</dt><dd><input type="text" value={this.state.user.allergies} onChange={e => this.setCastInfo({allergies: e.target.value})} /></dd>
            <dt>メモ</dt><dd><textarea value={this.state.user.memo} onChange={e => this.setCastInfo({memo: e.target.value})} /></dd>
          </dl>
        </div>
        ;
      }
    }

    const rank_list = cast_ranks.map((rank, i) => {
      return <option key={i} value={rank.key}>{rank.label}</option>
    })

    return <div className="admin">
    <Header />
      <div className="admin-sub-menus">
        <ul>
          <li className={ this.state.submenu === "lists" ? "active" : "" } onClick={e => this.changeSubMenu("lists")}>キャスト一覧</li>
          <li className={ this.state.submenu === "operation" ? "active" : "" } onClick={e => this.changeSubMenu("operation")}>オペレーション</li>
          <li className={ this.state.submenu === "add" ? "active" : "" } onClick={e => this.changeSubMenu("add")}>キャスト追加</li>
        </ul>
      </div>
      <div className="admin-contents-wrapper">
        <div className={ this.state.submenu === "lists" ? "admin-user-lists active" : "admin-user-lists" }>

          <div className={ this.state.alt === true ? "alt show" : "alt hide" } style={{ top: this.state.alt_y, left: this.state.alt_x }}>{this.state.alt_text}</div>
          <ul className="user-list-menu">
            <li><img alt="□" src={"/images/check_" + this.state.all_check + ".png"} onClick={e => allCheck(this.state.all_check, this.state.casts, (callback) => {this.setState(callback)})} className="checkbox_image" /></li>
            <li onClick={e => this.changeSubMenu("operations")}><span><FontAwesomeIcon icon={faEnvelope} />送信</span></li>
            <li><span><FontAwesomeIcon icon={faTrash} />削除</span></li>
            <li><span><FontAwesomeIcon icon={faFileCsv} /><CSVLink data={this.state.csv} headers={csv_headers}>ダウンロード</CSVLink></span></li>
            <li><Filter state={this.state} onChange={e => this.changeStateFromChild(e)} /></li>
          </ul>
          <ul className="user-list">
            <li className="user-list-title">
              <div></div>
              <div>属性</div>
              <div>画像</div>
              <div>氏名</div>
              <div>住所</div>
              <div>マンション</div>
              <div>最寄駅</div>
              <div>電話番号</div>
              <div>メールアドレス</div>
              <div></div>
              <div>登録日</div>
              <div>担当</div>
              <div>メモ</div>
              <div>管理</div>
            </li>
            {cast_detail_list}
          </ul>
        </div>

        <div className={ this.state.submenu === "operation" ? "admin-user-operation active" : "admin-user-operation" }>
          <ul className="side-menu">
            <Filter state={this.state} onChange={e => this.changeStateFromChild(e)} />
            <div className="side-list">
              {cast_list}
            </div>
          </ul>
          <div className="right-informations">
            
          </div>
          <div className="admin-contents messages">
            <div className="user-operation-menu">
              <ul>
                <li className={ this.state.contentmenu === "message" ? "active" : ""} onClick={e => this.setState({contentmenu: "message"})}>メッセージ</li>
                <li className={ this.state.contentmenu === "email" ? "active" : ""} onClick={e => this.setState({contentmenu: "email"})}>メール</li>
                <li className={ this.state.contentmenu === "schedule" ? "active" : ""} onClick={e => this.setState({contentmenu: "schedule"})}>スケジュール</li>
                <li className={ this.state.contentmenu === "edit" ? "active" : ""} onClick={e => this.setState({contentmenu: "edit"})}>情報編集</li>
              </ul>
              <br className="clear" />
            </div>
            <ul className={ this.state.contentmenu === "message" ? "chat-history active" : "chat-history"}>
              {message_list}
            </ul>
            <ul className={ this.state.contentmenu === "email" ? "email-history active" : "email-history"}>
              
            </ul>
            <ul className={ this.state.contentmenu === "schedule" ? "schedule-history active" : "schedule-history"}>
              <Calendar
                selectable
                onSelectEvent={event => this.onEventClick(event)}
                onSelectSlot={(slotInfo) => this.onSlotChange(slotInfo) }
                localizer={localizer}
                events={this.state.schedules}
                defaultView={Views.WEEK}
                startAccessor="start"
                endAccessor="end"
                min={new Date(2016, 10, 0, 9, 0, 0)}
                max={new Date(2016, 10, 0, 18, 0, 0)}
              />
            </ul>
            <ul className={ this.state.contentmenu === "payment" ? "payment-history active" : "payment-history"}>
              
            </ul>
            <ul className={ this.state.contentmenu === "edit" ? "user-edit active" : "user-edit"}>
              {user_edit()}
            </ul>
          </div>
          <div className={ this.state.contentmenu === "message" ? "chat" : "chat hide"} >
            <textarea placeholder="キャストにLINEメッセージを送信" value={this.state.message} onChange={e => this.setState({message: e.target.value})} />
            <button onClick={e => this.send(this.state.user_id, this.state.message)} value>送信</button>
          </div>
          <div className={ this.state.contentmenu === "email" ? "email" : "email hide"} >
            <input type="text" placeholder="件名" value={this.state.mail_title} onChange={e => this.setState({mail_title: e.target.value})} />
            <textarea placeholder="本文" value={this.state.mail_body} onChange={e => this.setState({mail_body: e.target.value})} />
            <select onChange={e => this.changeTemplate(e.target.value)}>
              <option value="">テンプレートを利用</option>
              
            </select>
            <button onClick={e => this.mailSend(this.state.user_id)} value>送信</button>
          </div>

          <div className={ this.state.contentmenu === "schedule" ? "schedule-history" : "schedule-history hide"} >
            <div className="reservation-conditions">
              <select value={this.state.date} onChange={e => this.setState({date: e.target.value})}>
                {dates}
              </select>
              <select value={this.state.start_time} onChange={e => this.setState({start_time: e.target.value})}>
                <option value="9:00">9:00</option>
                <option value="9:30">9:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
              </select>
              <select value={this.state.end_time} onChange={e => this.setState({end_time: e.target.value})}>
                <option value="9:30">9:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
                <option value="18:00">18:00</option>
              </select>
              <select value={this.state.repeat} onChange={e => this.setState({repeat: e.target.value})}>
                <option value="false">繰り返さない</option>
                <option value="true">繰り返す</option>
              </select>
              <button onClick={e => this.addSchedule(this.state.user_id)} value>{this.state.schedule_mode === 0 ? "空き枠追加" : "空き枠変更"}</button>
            </div>
          </div>


          <div className={ this.state.contentmenu === "edit" ? "user-edit" : "user-edit hide"} >
            <div className="reservation-conditions">
              <p>{this.state.user.editing === 1 ? "データ編集中(未確定)" : ""}</p>
              <button onClick={e => this.editConfirm(this.state.user_id)} value>更新</button>
            </div>
          </div>
        </div>

        <div className={ this.state.submenu === "add" ? "admin-user-add active" : "admin-user-add" }>
          <div className="sub-section">
            <div className="sub-section-title">キャスト追加</div>
            <dl>
              <dt>ランク</dt><dd><select name="rank" value={this.state.new_cast.rank} onChange={e => this.addCastInfo({rank: e.target.value})}>
                {rank_list}
              </select></dd>
              <dt>氏名</dt><dd><input type="text" value={this.state.new_cast.name} onChange={e => this.addCastInfo({name: e.target.value})} /></dd>
              <dt>フリガナ</dt><dd><input type="text" value={this.state.new_cast.name_kana} onChange={e => this.addCastInfo({name_kana: e.target.value})} /></dd>
              <dt>電話番号</dt><dd><input type="text" value={this.state.new_cast.tel} onChange={e => this.addCastInfo({tel: e.target.value})} /></dd>
              <dt>メールアドレス</dt><dd><input type="text" value={this.state.new_cast.email} onChange={e => this.addCastInfo({email: e.target.value})} /></dd>
              <dt>住所</dt><dd><input type="text" value={this.state.new_cast.address} onChange={e => this.addCastInfo({address: e.target.value})} /></dd>
              <dt>最寄駅</dt><dd><input type="text" value={this.state.new_cast.station} onChange={e => this.addCastInfo({station: e.target.value})} /></dd>
              <dt>緊急連絡先</dt><dd><input type="text" value={this.state.new_cast.emergency_tel} onChange={e => this.addCastInfo({emergency_tel: e.target.value})} /></dd>
              <dt>所有スマートフォン</dt><dd><input type="text" value={this.state.new_cast.smartphone} onChange={e => this.addCastInfo({smartphone: e.target.value})} /></dd>
              <dt>振込先銀行名</dt><dd><input type="text" value={this.state.new_cast.bank_name} onChange={e => this.addCastInfo({bank_name: e.target.value})} /></dd>
              <dt>振込先支店名</dt><dd><input type="text" value={this.state.new_cast.branch} onChange={e => this.addCastInfo({branch: e.target.value})} /></dd>
              <dt>振込先口座番号</dt><dd><input type="text" value={this.state.new_cast.account_number} onChange={e => this.addCastInfo({account_number: e.target.value})} /></dd>
              <dt>振込先口座名義</dt><dd><input type="text" value={this.state.new_cast.account_name} onChange={e => this.addCastInfo({account_name: e.target.value})} /></dd>
              <dt>家事代行（掃除）経験</dt><dd><select value={this.state.new_cast.skill_sweeping} onChange={e => this.addCastInfo({skill_sweeping: e.target.value})}>{skill_list}</select></dd>
              <dt>家事代行（料理）経験</dt><dd><select value={this.state.new_cast.skill_cooking} onChange={e => this.addCastInfo({skill_cooking: e.target.value})}>{skill_list}</select></dd>
              <dt>ハウスクリーニング経験</dt><dd><select value={this.state.new_cast.skill_cleaning} onChange={e => this.addCastInfo({skill_cleaning: e.target.value})}>{skill_list}</select></dd>
              <dt>ホームヘルパー経験</dt><dd><select value={this.state.new_cast.skill_helper} onChange={e => this.addCastInfo({skill_helper: e.target.value})}>{skill_list}</select></dd>
              <dt>介護経験</dt><dd><select value={this.state.new_cast.skill_care} onChange={e => this.addCastInfo({skill_care: e.target.value})}>{skill_list}</select></dd>
              <dt>飲食店経験</dt><dd><select value={this.state.new_cast.skill_restaurant} onChange={e => this.addCastInfo({skill_restaurant: e.target.value})}>{skill_list}</select></dd>
              <dt>その他清掃業務経験</dt><dd><select value={this.state.new_cast.skill_etc} onChange={e => this.addCastInfo({skill_etc: e.target.value})}>{skill_list}</select></dd>
              <dt>アレルギー</dt><dd><input type="text" value={this.state.new_cast.allergies} onChange={e => this.addCastInfo({allergies: e.target.value})} /></dd>
              <dt>メモ</dt><dd><textarea value={this.state.new_cast.memo} onChange={e => this.addCastInfo({memo: e.target.value})} /></dd>
              <dt></dt><dd><input type="button" value="キャスト追加" onClick={e => this.validation(e)} /></dd>
            </dl>
          </div>
        </div>
      </div>
    <Footer />
    </div>;
  }
}